import { Button, ButtonProps } from "@theprelude/ds";
import { Feature } from "@theprelude/sdk";
import { forwardRef, ReactNode } from "react";
import { DefaultTooltip } from "../default-tooltip";
import { useFeature } from "../flag/flag";

interface FlagButtonProps extends ButtonProps {
  flag: Feature;
  disabledTooltip: ReactNode;
  enabledTooltip?: ReactNode;
}

export const FlagButton = forwardRef<HTMLButtonElement, FlagButtonProps>(
  function FlagButton(
    { flag, disabled, disabledTooltip, enabledTooltip, ...props },
    ref,
  ) {
    const hasFlag = useFeature(flag);

    const buttonDisabled = disabled || !hasFlag;
    const tooltipDisabled =
      disabled ||
      ((!hasFlag || !enabledTooltip) && (hasFlag || !disabledTooltip));

    return (
      <DefaultTooltip
        asChild
        disabled={tooltipDisabled}
        content={hasFlag ? enabledTooltip : disabledTooltip}
      >
        <Button ref={ref} disabled={buttonDisabled} {...props} />
      </DefaultTooltip>
    );
  },
);
